// removed by extract-text-webpack-plugin
module.exports = {"container":"PageSelection__container___VyF7F","textButton":"PageSelection__textButton___1zIvJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/PageSelection/PageSelection.css
 ** module id = 717
 ** module chunks = 0
 **/